import {computed, signal} from "@preact/signals-react";

import {GROUPED_BY} from "@constants";


export const isLoadingShareOfSearch = signal(true)
export const isShareOfSearchEmpty = signal(false)
export const dataShareOfSearch = signal({})
export const shareOfSearchCurrentTab = signal(GROUPED_BY.BRAND)
export const shareOfSearchCurrentTabNormalize = signal('Brand')

// Computed
export const shareOfSearchCurrentData = computed(() => dataShareOfSearch.value[shareOfSearchCurrentTab.value] || [])
export const shareOfSearchIsCountryCurrent = computed(() => shareOfSearchCurrentTab.value === GROUPED_BY.COUNTRY)
export const shareOfSearchIsRetailerCurrent = computed(() => shareOfSearchCurrentTab.value === GROUPED_BY.RETAILER)
export const shareOfSearchIsCategoryCurrent = computed(() => shareOfSearchCurrentTab.value === GROUPED_BY.CATEGORY)
export const shareOfSearchIsBrandCurrent = computed(() => shareOfSearchCurrentTab.value === GROUPED_BY.BRAND)